import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxAlternatePayerId,
    taxName,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxAlternatePayerId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAlternatePayerId.invalidMsg)
    .required(taxAlternatePayerId.errorMsg),
  [taxName.name]: Yup.string().required(taxName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
